import { LocaleContext } from "./context";
import { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { ILocalizedText } from "./services/typings";
import { get, isString } from "lodash";
import initI18n from "./i18n";

export const useLocale = () => {
  return useContext(LocaleContext);
};

export const useLocalizedText = (data?: ILocalizedText | string) => {
  const { language } = useLocale();
  const localizedText: string | undefined = useMemo(
    () => (isString(data) ? data : get(data, language) || get(data, "en")),
    [data, language]
  );
  return localizedText;
};

export const useGetLocalizedText = () => {
  const { language } = useLocale();
  return useCallback(
    (data?: ILocalizedText | string) => {
      return isString(data) ? data : get(data, language) || get(data, "en");
    },
    [language]
  );
};

export const useInitLocale = () => {
  const [error, setError] = useState<any>(null);

  const init = useCallback(async () => {
    try {
      await initI18n();
      setError(null);
    } catch (e) {
      setError(e);
    }
  }, []);

  return [init, false, error] as const;
};
